import type { ICampaign } from "../../../../types/models/campaign.models.types";
import type { ISocial } from "../../../../types/models/social.models.types";
import { usePostHttp } from "../../http.hook";

interface IResponse {
  campaign: ICampaign;
}
export interface IFixedPayoutSocialsMinimal {
  social: string;
  amount: number;
  handle?: string;
}

export interface IFixedPayoutSocials extends IFixedPayoutSocialsMinimal {
  socialInfo: ISocial;
}

interface IBody {
  fixedPayoutSocials: Array<IFixedPayoutSocialsMinimal>;
}

export function useAddFixedPayoutToCampaignAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/campaigns/:campaignId/fixed-payout",
  });
}
